import request from '../utils/request'

export default {
  async list (data) {
    const ret = await request('/v1/leave/list', data,'POST')
    return ret
  },
  async save (data) { 
    const ret = await request('/v1/leave/save', data,'POST')
    return ret
  },
  async approve (data) {
    const ret = await request('/v1/leave/approve', data,'POST')
    return ret
  },
  async withdraw (data) {
    const ret = await request('/v1/leave/withdraw', data,'POST')
    return ret
  },
  async delete (data) { 
    const ret = await request('/v1/leave/delete', data,'POST')
    return ret
  }
}
